// extracted by mini-css-extract-plugin
module.exports = {"root":"root--3psY2","hero":"hero--3Cp3P","title":"title--1R4Mw","btn":"btn--1SukZ","jumpAfter":"jumpAfter--Mm7W7","jumpBefore":"jumpBefore--2_6bk"};